import script from "./SearchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=d6df27e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6df27e8"]])

export default __exports__